var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIndicatorTriangle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 7,
    viewBox: "0 0 8 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.27639 5.55279L4.89443 0.788854C4.5259 0.051806 3.4741 0.0518051 3.10557 0.788854L0.723607 5.55279C0.391156 6.21769 0.874652 7 1.61803 7H6.38197C7.12535 7 7.60884 6.21769 7.27639 5.55279Z",
    fill: "#223BF4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIndicatorTriangle);
export default __webpack_public_path__ + "static/media/indicator-triangle.dcc068d82c89bee3a005abfb22bf7bb7.svg";
export { ForwardRef as ReactComponent };